import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
} from '@mui/material';
import {
  Close as CloseIcon,
  PictureAsPdf as PdfIcon,
  Description as DocIcon,
  Image as ImageIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';

const CompleteReviewDialog = ({ open, onClose, onSubmit, documents = [] }) => {
  // 获取文件图标
  const getFileIcon = (fileType) => {
    switch (fileType) {
      case 'pdf':
        return <PdfIcon sx={{ color: '#f44336' }} />;
      case 'image':
        return <ImageIcon sx={{ color: '#4caf50' }} />;
      default:
        return <DocIcon sx={{ color: '#2196f3' }} />;
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0',
        pb: 2
      }}>
        <Typography variant="h6" sx={{ color: '#1976d2' }}>
          Review Summary
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <List>
          {[
            // 添加摘要报告作为第一个文件
            {
              name: 'Review Summary Report.pdf',
              type: 'pdf',
              reviewDate: new Date().toLocaleDateString(),
              status: 'approved'
            },
            // 展开其他文档
            ...documents
          ].map((doc, index) => (
            <ListItem
              key={index}
              sx={{
                bgcolor: '#fff',
                borderRadius: 1,
                mb: 1,
                border: '1px solid #e0e0e0',
              }}
            >
              <ListItemIcon>
                {getFileIcon(doc.type)}
              </ListItemIcon>
              <ListItemText 
                primary={doc.name}
                secondary={`Reviewed on ${doc.reviewDate}`}
              />
              <Chip
                icon={<CheckCircleIcon fontSize="small" />}
                label="Reviewed"
                color="success"
                size="small"
                variant="outlined"
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0' }}>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          sx={{
            bgcolor: '#4caf50',
            '&:hover': {
              bgcolor: '#388e3c'
            }
          }}
        >
          Submit Review
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteReviewDialog; 